export const PROCESS_UPDATE_USER_CONFIG: string = 'PROCESS_UPDATE_USER_CONFIG' // CHANGE
export const PROCESS_FORM_UPDATE: string = 'PROCESS_FORM_UPDATE'
export const ERROR: string = 'ERROR'

